var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 11.3718C32.0104 9.65433 30.5643 7.80015 29.4287 7.2141C30.3529 9.02597 30.8878 10.8435 31.0922 12.2C31.0922 12.2026 31.0932 12.2093 31.0954 12.2273C29.2377 7.59712 26.0878 5.73009 23.5157 1.66489C23.3858 1.45934 23.2555 1.25323 23.1287 1.03599C23.0641 0.92504 23.0037 0.811663 22.9478 0.696106C22.8409 0.489787 22.7585 0.271705 22.7022 0.0462817C22.7026 0.0356097 22.699 0.0251762 22.6921 0.0170305C22.6851 0.00888486 22.6754 0.00361578 22.6649 0.00225828C22.6548 -0.00063069 22.6441 -0.00063069 22.634 0.00225828C22.6317 0.00307859 22.6283 0.00574461 22.6258 0.00670164C22.6222 0.00813719 22.6176 0.0114184 22.6138 0.0135376C22.6156 0.0110766 22.6195 0.00553953 22.6206 0.0042407C18.4938 2.42115 17.0938 6.8922 16.9651 9.12912C15.3171 9.24242 13.7415 9.84958 12.4437 10.8715C12.3078 10.7567 12.1658 10.6494 12.0182 10.5502C11.6437 9.24013 11.6278 7.85359 11.9721 6.53529C10.2844 7.30372 8.97179 8.5184 8.01749 9.59096H8.0099C7.35864 8.76607 7.40458 6.04495 7.4417 5.47682C7.43391 5.44161 6.95587 5.72496 6.89325 5.76769C6.31856 6.17789 5.78131 6.63815 5.28776 7.14308C4.72614 7.71262 4.21299 8.32801 3.75364 8.98283C3.75364 8.98365 3.75316 8.98461 3.75289 8.98543C3.75289 8.98454 3.75337 8.98365 3.75364 8.98283C2.69724 10.4799 1.94801 12.1714 1.54926 13.9597C1.5414 13.9954 1.53477 14.0323 1.52711 14.0682C1.49621 14.2128 1.38492 14.9363 1.36544 15.0935C1.36394 15.1056 1.36325 15.1173 1.36182 15.1294C1.21794 15.8774 1.12883 16.6349 1.09521 17.396C1.09521 17.424 1.09351 17.4517 1.09351 17.4798C1.09378 26.552 8.44925 33.9062 17.5222 33.9062C25.6477 33.9062 32.3944 28.0077 33.7153 20.2597C33.7431 20.0494 33.7654 19.838 33.7899 19.6259C34.1165 16.8088 33.7537 13.8478 32.7244 11.3718ZM13.7892 24.2298C13.866 24.2665 13.9382 24.3066 14.0171 24.3418C14.0204 24.3441 14.0249 24.3466 14.0283 24.3487C13.948 24.3103 13.8683 24.2706 13.7892 24.2298ZM31.0967 12.2313L31.0945 12.2154C31.0953 12.2212 31.0964 12.2273 31.0973 12.2331L31.0967 12.2313Z",
    fill: "url(#paint0_linear_23156_15774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 11.3718C32.0104 9.65434 30.5642 7.80016 29.4287 7.21411C30.3529 9.02598 30.8878 10.8435 31.0922 12.2C31.0922 12.196 31.0929 12.2033 31.0946 12.2154C31.0955 12.2212 31.0965 12.2273 31.0974 12.2331C32.6474 16.4352 31.803 20.7082 30.5861 23.3193C28.7036 27.3593 24.1456 31.4999 17.0116 31.2979C9.30373 31.0797 2.51332 25.3605 1.24573 17.8698C1.01474 16.6886 1.24573 16.0888 1.36194 15.1297C1.22037 15.8691 1.16643 16.0826 1.09534 17.3963C1.09534 17.4243 1.09363 17.4521 1.09363 17.4802C1.09376 26.552 8.44923 33.9063 17.5222 33.9063C25.6477 33.9063 32.3944 28.0077 33.7153 20.2597C33.7431 20.0494 33.7654 19.838 33.7899 19.6259C34.1165 16.8088 33.7537 13.8478 32.7244 11.3718Z",
    fill: "url(#paint1_radial_23156_15774)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 11.3718C32.0104 9.65434 30.5642 7.80016 29.4287 7.21411C30.3529 9.02598 30.8878 10.8435 31.0922 12.2C31.0922 12.196 31.0929 12.2033 31.0946 12.2154C31.0955 12.2212 31.0965 12.2273 31.0974 12.2331C32.6474 16.4352 31.803 20.7082 30.5861 23.3193C28.7036 27.3593 24.1456 31.4999 17.0116 31.2979C9.30373 31.0797 2.51332 25.3605 1.24573 17.8698C1.01474 16.6886 1.24573 16.0888 1.36194 15.1297C1.22037 15.8691 1.16643 16.0826 1.09534 17.3963C1.09534 17.4243 1.09363 17.4521 1.09363 17.4802C1.09376 26.552 8.44923 33.9063 17.5222 33.9063C25.6477 33.9063 32.3944 28.0077 33.7153 20.2597C33.7431 20.0494 33.7654 19.838 33.7899 19.6259C34.1165 16.8088 33.7537 13.8478 32.7244 11.3718Z",
    fill: "url(#paint2_radial_23156_15774)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7407 13.3027C24.7766 13.3279 24.8091 13.3529 24.8428 13.3779C24.4305 12.6462 23.9171 11.9762 23.3177 11.3879C18.2109 6.28168 21.9786 0.316233 22.614 0.0132642C22.6158 0.0108032 22.6197 0.00526611 22.6208 0.00396729C18.494 2.42088 17.094 6.89193 16.9653 9.12885C17.1567 9.11559 17.3476 9.09952 17.5424 9.09952C20.6221 9.09952 23.3044 10.7928 24.7407 13.3027Z",
    fill: "url(#paint3_radial_23156_15774)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5527 14.3223C17.5259 14.7309 16.082 16.1401 15.5771 16.1401C10.9055 16.1401 10.1472 18.9658 10.1472 18.9658C10.3541 21.3454 12.0108 23.3049 14.0171 24.3418C14.1086 24.3891 14.2013 24.4318 14.294 24.474C14.4529 24.5444 14.6138 24.6102 14.7765 24.6713C15.4644 24.9149 16.185 25.0538 16.9142 25.0836C25.1023 25.4676 26.6886 15.2949 20.7796 12.3409C22.2928 12.0777 23.8636 12.6863 24.7408 13.3025C23.3044 10.7927 20.6221 9.09946 17.5425 9.09946C17.3477 9.09946 17.1569 9.11552 16.9654 9.12878C15.3175 9.24208 13.7419 9.84924 12.444 10.8711C12.6945 11.083 12.9772 11.3663 13.5729 11.9531C14.6873 13.0514 17.5466 14.1888 17.5527 14.3223Z",
    fill: "url(#paint4_radial_23156_15774)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5527 14.3223C17.5259 14.7309 16.082 16.1401 15.5771 16.1401C10.9055 16.1401 10.1472 18.9658 10.1472 18.9658C10.3541 21.3454 12.0108 23.3049 14.0171 24.3418C14.1086 24.3891 14.2013 24.4318 14.294 24.474C14.4529 24.5444 14.6138 24.6102 14.7765 24.6713C15.4644 24.9149 16.185 25.0538 16.9142 25.0836C25.1023 25.4676 26.6886 15.2949 20.7796 12.3409C22.2928 12.0777 23.8636 12.6863 24.7408 13.3025C23.3044 10.7927 20.6221 9.09946 17.5425 9.09946C17.3477 9.09946 17.1569 9.11552 16.9654 9.12878C15.3175 9.24208 13.7419 9.84924 12.444 10.8711C12.6945 11.083 12.9772 11.3663 13.5729 11.9531C14.6873 13.0514 17.5466 14.1888 17.5527 14.3223Z",
    fill: "url(#paint5_radial_23156_15774)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6777 10.3247C11.7922 10.3985 11.9057 10.4737 12.0182 10.5503C11.6438 9.24027 11.6279 7.85372 11.9722 6.53543C10.2845 7.30386 8.97188 8.51854 8.01758 9.5911C8.09653 9.58884 10.4795 9.54598 11.6777 10.3247Z",
    fill: "url(#paint6_radial_23156_15774)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24573 17.8698C2.51332 25.3605 9.30373 31.0797 17.0116 31.2979C24.1456 31.4999 28.7036 27.3591 30.5861 23.3193C31.8029 20.708 32.6474 16.4355 31.0974 12.2331L31.0968 12.2313L31.0946 12.2154C31.0929 12.2032 31.0919 12.196 31.0922 12.2C31.0922 12.2026 31.0932 12.2093 31.0954 12.2273C31.6781 16.0323 29.7426 19.7184 26.7169 22.2108L26.7078 22.2322C20.8122 27.0326 15.1705 25.1284 14.0282 24.349C13.948 24.3104 13.8682 24.2706 13.789 24.2298C10.3517 22.5872 8.93178 19.4558 9.23626 16.7702C6.33392 16.7702 5.34428 14.3223 5.34428 14.3223C5.34428 14.3223 7.95007 12.4644 11.3844 14.0803C14.5651 15.5768 17.5523 14.3225 17.5527 14.3223C17.5466 14.1889 14.6872 13.0515 13.5726 11.9533C12.9769 11.3665 12.6941 11.0835 12.4437 10.8713C12.3078 10.7565 12.1657 10.6492 12.0181 10.55C11.9054 10.4736 11.7919 10.3984 11.6776 10.3244C10.4794 9.54564 8.09643 9.5885 8.01748 9.59055H8.00989C7.35863 8.76566 7.40457 6.04454 7.44168 5.47641C7.43389 5.4412 6.95585 5.72455 6.89324 5.76728C6.31855 6.17748 5.78129 6.63774 5.28775 7.14267C4.72611 7.71234 4.21296 8.32786 3.75363 8.98283C3.75363 8.98366 3.75315 8.98461 3.75288 8.98543C3.75288 8.98454 3.75335 8.98366 3.75363 8.98283C2.69723 10.4799 1.948 12.1714 1.54924 13.9597C1.54138 13.9954 0.957935 16.5466 1.24573 17.8698Z",
    fill: "url(#paint7_radial_23156_15774)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3177 11.3878C23.9171 11.9762 24.4305 12.6461 24.8428 13.3779C24.9333 13.4458 25.0177 13.5136 25.0895 13.5797C28.8138 17.0113 26.8624 21.8648 26.7169 22.2107C29.7425 19.7183 31.6781 16.0322 31.0954 12.2272C29.2377 7.59712 26.0878 5.73009 23.5156 1.66489C23.3857 1.45934 23.2555 1.25323 23.1286 1.03599C23.064 0.92504 23.0037 0.811663 22.9478 0.696106C22.8409 0.489787 22.7585 0.271705 22.7021 0.0462817C22.7025 0.0356097 22.6989 0.0251762 22.692 0.0170305C22.6851 0.00888486 22.6754 0.00361578 22.6648 0.00225828C22.6547 -0.00063069 22.6441 -0.00063069 22.634 0.00225828C22.6317 0.00307859 22.6282 0.00574461 22.6258 0.00670164C22.6222 0.00813719 22.6176 0.0114184 22.6137 0.0135376C21.9786 0.316233 18.2109 6.28168 23.3177 11.3878Z",
    fill: "url(#paint8_radial_23156_15774)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0895 13.5797C25.0178 13.5136 24.9333 13.4458 24.8428 13.3779C24.8094 13.3527 24.7766 13.3277 24.7408 13.3027C23.8636 12.6865 22.2928 12.0779 20.7795 12.3411C26.6886 15.2951 25.1022 25.4678 16.9142 25.0838C16.185 25.054 15.4644 24.9151 14.7765 24.6715C14.6138 24.6103 14.4529 24.5445 14.2939 24.4742C14.2013 24.432 14.1086 24.3893 14.0171 24.342C14.0204 24.3442 14.0249 24.3467 14.0282 24.3488C15.1705 25.1281 20.8121 27.0324 26.7078 22.232L26.7169 22.2106C26.8624 21.8651 28.8138 17.0114 25.0895 13.5797Z",
    fill: "url(#paint9_radial_23156_15774)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1472 18.9658C10.1472 18.9658 10.9055 16.1402 15.5771 16.1402C16.0822 16.1402 17.526 14.731 17.5527 14.3223C17.5795 13.9137 14.5654 15.5769 11.3845 14.0803C7.95015 12.4644 5.34436 14.3223 5.34436 14.3223C5.34436 14.3223 6.334 16.7702 9.23633 16.7702C8.93193 19.4558 10.3519 22.5876 13.7891 24.2299C13.8659 24.2666 13.9381 24.3067 14.017 24.3419C12.0108 23.3049 10.3541 21.3454 10.1472 18.9658Z",
    fill: "url(#paint10_radial_23156_15774)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 11.3718C32.0104 9.65433 30.5642 7.80015 29.4286 7.2141C30.3529 9.02597 30.8878 10.8435 31.0922 12.2C31.0922 12.2026 31.0932 12.2093 31.0954 12.2273C29.2377 7.59712 26.0878 5.73009 23.5156 1.66489C23.3857 1.45934 23.2555 1.25323 23.1286 1.03599C23.064 0.92504 23.0037 0.811663 22.9478 0.696106C22.8409 0.489787 22.7585 0.271705 22.7022 0.0462817C22.7025 0.0356097 22.6989 0.0251762 22.692 0.0170305C22.6851 0.00888486 22.6754 0.00361578 22.6648 0.00225828C22.6548 -0.00063069 22.6441 -0.00063069 22.634 0.00225828C22.6317 0.00307859 22.6283 0.00574461 22.6258 0.00670164C22.6222 0.00813719 22.6176 0.0114184 22.6138 0.0135376C22.6156 0.0110766 22.6194 0.00553953 22.6206 0.0042407C18.4937 2.42115 17.0937 6.8922 16.9651 9.12912C17.1565 9.11586 17.3474 9.0998 17.5422 9.0998C20.622 9.0998 23.3043 10.7931 24.7404 13.3028C23.8632 12.6866 22.2925 12.078 20.7792 12.3412C26.6883 15.2953 25.1019 25.468 16.9138 25.0839C16.1847 25.0542 15.4641 24.9152 14.7762 24.6716C14.6135 24.6105 14.4526 24.5447 14.2936 24.4744C14.2009 24.4321 14.1083 24.3894 14.0167 24.3421C14.02 24.3443 14.0245 24.3469 14.0279 24.3489C13.9476 24.3103 13.8678 24.2706 13.7886 24.2298C13.8655 24.2665 13.9377 24.3066 14.0165 24.3418C12.0102 23.3049 10.3536 21.3454 10.1467 18.9658C10.1467 18.9658 10.905 16.1402 15.5766 16.1402C16.0816 16.1402 17.5254 14.731 17.5522 14.3223C17.5461 14.1889 14.6867 13.0515 13.5721 11.9533C12.9765 11.3665 12.6937 11.0835 12.4432 10.8713C12.3073 10.7565 12.1652 10.6492 12.0176 10.55C11.6432 9.23993 11.6273 7.85338 11.9716 6.53509C10.2839 7.30352 8.97128 8.5182 8.01698 9.59075H8.0094C7.35814 8.76586 7.40407 6.04475 7.44119 5.47661C7.4334 5.44141 6.95536 5.72476 6.89275 5.76748C6.31806 6.17769 5.7808 6.63795 5.28726 7.14287C4.72579 7.7125 4.2128 8.32795 3.75361 8.98283C3.75361 8.98365 3.75313 8.98461 3.75286 8.98543C3.75286 8.98454 3.75334 8.98365 3.75361 8.98283C2.69721 10.4799 1.94798 12.1714 1.54923 13.9597C1.54137 13.9954 1.53474 14.0323 1.52708 14.0682C1.49618 14.2128 1.35714 14.9468 1.33772 15.1042C1.33622 15.1163 1.33916 15.0922 1.33772 15.1042C1.21093 15.8627 1.13003 16.6281 1.09546 17.3963C1.09546 17.4243 1.09375 17.4521 1.09375 17.4802C1.09375 26.552 8.44922 33.9062 17.5222 33.9062C25.6477 33.9062 32.3944 28.0077 33.7153 20.2597C33.7431 20.0494 33.7654 19.838 33.7899 19.6259C34.1165 16.8088 33.7537 13.8478 32.7244 11.3718ZM31.0946 12.2154C31.0955 12.2212 31.0965 12.2273 31.0974 12.2331L31.0968 12.2313L31.0946 12.2154Z",
    fill: "url(#paint11_linear_23156_15774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23156_15774",
    x1: 2864.01,
    y1: 525.545,
    x2: 226.107,
    y2: 3070.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2295.15 -337.106) scale(3360.01 3416.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1319.31 1074.9) scale(3444.01 3416.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395.083 -160.484) scale(1102.84 1872.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.297 1770.28) scale(1459.36 1599.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(692.111 536.925) scale(774.918 943.689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(848.157 -394.953) scale(1160.19 1164.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2586.04 -1053.62) scale(5539.01 4649.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(383.514 1714.98 -7704.63 380.601 430.715 68.5135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.139 -544.703) scale(3180.2 3124.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_23156_15774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1950.17 -475.012) scale(3822.5 3419.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_23156_15774",
    x1: 2626.09,
    y1: 474.686,
    x2: 516.69,
    y2: 2779.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserFirefox);
export default __webpack_public_path__ + "static/media/browser_firefox.e9fd8f1b2cfd0a594bdc098184cd4112.svg";
export { ForwardRef as ReactComponent };